import { brandAssets } from '@echo/brand';
import mascotSupport from '@echo/brand/assets/mascot-support.png';
import { SUPPORT_EMAIL } from '@echo/core';
import { Button } from '@echo/ui-web';
import { Trans, useLingui } from '@lingui/react/macro';
import { createFileRoute, Link } from '@tanstack/react-router';
import { EmptyStateArt, EmptyStateFrame, ToolbarBack } from '@/components/empty-state-frame';
import { VersionDetails } from '@/components/version-details';
import { appConfig } from '@/lib/config';

export const Route = createFileRoute('/_app/account_/help')({ component: HelpPage });

/**
 * Account › Help & Support: the coaches with an @ sign, a
 * short invitation to write, and "Email support" opening the mail app on the support address.
 * Under it, quietly, the version and build to read out to support (PRD-2473).
 */
function HelpPage() {
  const { t } = useLingui();
  const backLink = ({ className, children }: { className: string; children: React.ReactNode }) => (
    <Link to="/account" className={className}>
      {children}
    </Link>
  );
  return (
    <>
      <ToolbarBack render={backLink} />
      <EmptyStateFrame
        art={
          <EmptyStateArt
            src={mascotSupport}
            alt={t`A cheerful brain character in a headset holding a heart`}
            width={brandAssets.mascotSupport.width}
            height={brandAssets.mascotSupport.height}
          />
        }
        title={<Trans>We're here to help</Trans>}
        actions={
          <>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="inline-flex min-h-tap-target items-center justify-center rounded-sm px-content-sm py-internal-sm text-center font-brand text-label-md text-on-action-secondary hover:bg-action-secondary-focus focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-highlight"
            >
              <Trans>Email support</Trans>
            </a>
            <Link to="/account">
              <Button tabIndex={-1}>
                <Trans>Back</Trans>
              </Button>
            </Link>
          </>
        }
      >
        <Trans>
          Have a question or need some support with StrongerMemory? Send us an email and a member of
          our team will be happy to help.
        </Trans>
      </EmptyStateFrame>
      <VersionDetails build={appConfig} />
    </>
  );
}
